import { useTranslation } from "react-i18next";
import InputField from "../../components/shared/InputField";
import MultiSelect from "../../components/shared/MultiSelect";
import NormalButton from "../../components/shared/NormalButton";
import PageHeader from "../../components/shared/PageHeader";
import MainContent from "../../containers/shared/MainContent";
import NormalFormContainer from "../../containers/shared/NormalFormContainer";
import PageMain from "../../containers/shared/PageMain";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import { useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import apiClient from "../../components/utils/apiClient";
import Loading from "../../components/shared/Loading";
import DateField from "../../components/shared/DateField";
import {initializeApp, getApp, getApps} from "firebase/app";
import { getStorage, uploadBytes } from "firebase/storage";
import { getDownloadURL, ref } from "firebase/storage";
import { firebaseConfig } from "../../components/utils/constants";
import moment from "moment";
import { useRef } from "react";
import MultiImagesCompress from "../../components/helpers/MultiImagesCompress";
import ModalContainer from "../../containers/shared/ModalContainer";
import useUser from "../../components/helpers/useUser";

const AssetsEditPage = () => {

    const [user, setUser] = useUser();

    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const AttachmentFilesRef = useRef(null);
    const [attachmentsFiles, setAttachmentsFiles] = useState([]);
    const { AssetTypeOptions, AssetsStatusOptions } = useContext(UserContext);
    const {t,i18n} = useTranslation();
    useDocumentTitle('تعديل أصل');
    const navigate = useNavigate();
    const pageTitle = {title: 'تعديل أصل', subTitle: 'يمكنك تعديل أصل من هنا.'};
    const EmptyEditAssetsForm = {
        type: "",
        status: "",
        brand: "",
        serialNumber: "",
        costPerItem: "",
        depreciationRate: "",
        propertyId: "",
        quantity:0,
        unitId: "",
        purchaseDate: "",
        installationDate: "",
        lastMaintenanceDate: "",
        expectedLifeSpan: "",
        hasWarranty: "",
        attachments: [],
    };
    const [editAssetsForm,setEditAssetsForm] = useState(EmptyEditAssetsForm);
    const [errors, setErrors] = useState(null);
    const [isEditAssetsFormDisabled, setIsEditAssetsFormDisabled] = useState(true);

    const [deleteAssetModal, setDeleteAssetModal] = useState(false);


    const [unitsOptions, setUnitsOptions] = useState([]);
        const getUnits = async () => {
        try {
            const response = await apiClient.get(`/b-units?business=${user?.business?._id ? user?.business._id : user?.business}`);
            if(response?.data) {
              setUnitsOptions(response?.data?.filter(u=>!u?.deletedAt)?.map(unit => ({value: unit?._id, label: unit?.name, propertyId: unit?.propertyId})));
            }
          } catch(err) {}
      }
      useEffect(()=>{
        getUnits();
      },[])

    useEffect(()=>{
        if(id) {
            getAsset();
        }
    },[id]);


    const getAsset = async () => {
        try {
          const response = await apiClient.get(`/b-assets/${id}`);
          if(response?.data) {
            let data = response?.data;
            setEditAssetsForm(data);
          } else {
  
          }
        } catch(err) {}
      }

    const handleSubmitEditAssets = async () => {
        setIsEditAssetsFormDisabled(true);
        if(attachmentsFiles?.length > 0) { 
            setIsLoading(true);
            MultiImagesCompress(attachmentsFiles).then(compressedImages=>uploadFiles(compressedImages));
        } else {
            sendToServer();
        }
    }

    const uploadFiles = async(files) => {
        await Promise.all(files.map(async (file,index) => await singleFileUpload(file,index)  ))
    .then((resolvedFiles) => {
        sendToServer(resolvedFiles);
    })
    .catch(error => {
        console.error(`Error occured during images uploading: ${error}`);
    });
    }

    const singleFileUpload = async (file,index) => {
        const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
        const storage = getStorage(app);
        const time = Date.parse(moment().locale('en').format('YYYY-MM-DD HH:mm:ss')) / 1000;
        const storageRef = ref(storage,'fanni-business/AssetsWarrenty/'+time+'-'+index);

        const imageToServer = uploadBytes(storageRef,file);
        return await imageToServer.then((snapshot) => {
        return getDownloadURL(snapshot.ref).then( url => {
            return { url : url, name: file.name, type: file.type }
        });
        ;
        });
    }

            

    const sendToServer = async (files=null) => {
        const finalEditAssetsForm = JSON.parse(JSON.stringify(editAssetsForm));
        finalEditAssetsForm.costPerItem = parseInt(finalEditAssetsForm.costPerItem);
        finalEditAssetsForm.depreciationRate = parseFloat(finalEditAssetsForm.depreciationRate);
        finalEditAssetsForm.expectedLifeSpan = parseInt(finalEditAssetsForm.expectedLifeSpan);
        if(files) {
            finalEditAssetsForm.attachments = [...finalEditAssetsForm.attachments, ...files];
        }
        if(finalEditAssetsForm?.unitId?._id) {
            finalEditAssetsForm.unitId = finalEditAssetsForm?.unitId?._id;
        }
        if(finalEditAssetsForm?.propertyId?._id) {
            finalEditAssetsForm.propertyId = finalEditAssetsForm?.propertyId?._id;
        }
        try {
        const response = await apiClient.put(`/b-assets/${id}`,finalEditAssetsForm);
        if(response?.data) {
            navigate(`/ar/assets`);
            setIsLoading(false);
        } else {
            setIsEditAssetsFormDisabled(false);
            setIsLoading(false);
        }
        } catch(err) {
            setIsEditAssetsFormDisabled(false);
            setIsLoading(false);
            if(err?.response?.data?.errors) {
                let errorsList = {};
                err?.response?.data?.errors?.map(err=>{
                    errorsList[err.field] = err.message; 
                });
                setErrors(errorsList);
            }
        }
    }

    const hideError = (err) => {
      if(errors) {
        let errorsList = errors;
        delete errorsList[err];
        setErrors(errorsList);
      }
    }

    useEffect(()=>{
        if(editAssetsForm 
            && editAssetsForm?.type && editAssetsForm?.type !== ''
            && editAssetsForm?.status && editAssetsForm?.status !== ''
            && editAssetsForm?.brand && editAssetsForm?.brand !== ''
            && editAssetsForm?.serialNumber && editAssetsForm?.serialNumber !== ''
            && editAssetsForm?.costPerItem && editAssetsForm?.costPerItem !== ''
            && editAssetsForm?.depreciationRate && editAssetsForm?.depreciationRate !== ''
            && editAssetsForm?.unitId && editAssetsForm?.unitId !== ''
            && editAssetsForm?.purchaseDate && editAssetsForm?.purchaseDate !== ''
            && editAssetsForm?.lastMaintenanceDate && editAssetsForm?.lastMaintenanceDate !== ''
            && editAssetsForm?.expectedLifeSpan && editAssetsForm?.expectedLifeSpan !== ''
            && editAssetsForm?.hasWarranty !== '' && [true,false].includes(editAssetsForm?.hasWarranty)) {
            setIsEditAssetsFormDisabled(false);
        } else {
            setIsEditAssetsFormDisabled(true);
        }
    },[editAssetsForm])



    const depreciationRateOptions = [
        {label:'1%', value: '0.01'},
        {label:'2%', value: '0.02'},
        {label:'3%', value: '0.03'},
        {label:'4%', value: '0.04'},
        {label:'5%', value: '0.05'},
        {label:'6%', value: '0.06'},
        {label:'7%', value: '0.07'},
        {label:'8%', value: '0.08'},
        {label:'9%', value: '0.09'},
        {label:'10%', value: '0.1'},
    ]

    const TrueOrFalseOptions = [
        {label:'نعم', value: true},
        {label:'لا', value: false},
    ]


    const handleClickAttachments = () => {
        AttachmentFilesRef.current.click();
    }

    const handleChangeAttachments = (e) => {
        setAttachmentsFiles([...attachmentsFiles, ...Array.from(e.target.files)]);
    }

    const removeAttachment = (file) => {
        const newAttachmentsFiles = [...Array.from(attachmentsFiles).filter((f) => f?.name !== file?.name)];
        setAttachmentsFiles(newAttachmentsFiles);
    }

    const removeUploadedAttachment = (file) => {
        const newAttachmentsFiles = [...Array.from(editAssetsForm?.attachments).filter((f) => f?.name !== file?.name)];
        setEditAssetsForm({ ...editAssetsForm, attachments: newAttachmentsFiles });
    }

    const handleSubmitDeleteِAsset = () => {
        setDeleteAssetModal(true);
    }

    const handleSubmitDeleteInventoryAction = async () => {

        try {
            const response = await apiClient.delete(`/b-assets/${id}`);
            if(response?.data || response?.status === 204) {
                navigate(`/ar/assets`);
            } else {
                setIsEditAssetsFormDisabled(false);
            }
        } catch(err) {setIsEditAssetsFormDisabled(false);}

    }

    const handleCloseModalDelete = () => {
        setDeleteAssetModal(false);
    }


    
    return (
        <div> 
        <PageHeader pageTitle={pageTitle} />
        <PageMain>
            <span className="absolute top-0 left-0 right-0 bottom-0 z-0 bg-grey-50"></span>
            <MainContent>
                <NormalFormContainer heading="من فضلك قم بتغيير البيانات التالية لتعديل الأصل" label="تعديل اصل">
                    
                    <div className="mb-[15px]">
                        <InputField label={'الاسم'} placeholder={'اكتب اسم الأصل'} value={editAssetsForm?.brand} error={errors?.brand} errorMessage={errors?.brand} translateError={true} onChange={(e)=>{setEditAssetsForm({ ...editAssetsForm, brand: e.target.value }); hideError('brand')}} />
                    </div>
                    
                    <div className="mb-[15px]">
                        <MultiSelect label={'النوع'} placeholder={'اختر نوع الأصل'} options={AssetTypeOptions} error={errors?.type} errorMessage={errors?.type} value={editAssetsForm?.type} onChange={(option)=>{setEditAssetsForm({ ...editAssetsForm, type: option?.value }); hideError('type')}} />
                    </div>

                    <div className="mb-[15px]">
                        <MultiSelect label={'الحالة'} placeholder={'اختر حالة الأصل'} options={AssetsStatusOptions} error={errors?.status} errorMessage={errors?.status} value={editAssetsForm?.status} onChange={(option)=>{setEditAssetsForm({ ...editAssetsForm, status: option?.value }); hideError('status')}} />
                    </div>


                    <div className="mb-[15px]">
                        <InputField label={'رقم السريال'} placeholder={'اكتب رقم السريال هنا'} value={editAssetsForm?.serialNumber} error={errors?.serialNumber} errorMessage={errors?.serialNumber} translateError={true} onChange={(e)=>{ setEditAssetsForm({ ...editAssetsForm, serialNumber: e.target.value }); hideError('serialNumber')}} />
                    </div>

                    <div className="mb-[15px] relative">
                        <InputField label={'القيمة'} placeholder={'اكتب سعر الأصل هنا'} value={editAssetsForm?.costPerItem} error={errors?.costPerItem} errorMessage={errors?.costPerItem} translateError={true} onChange={(e)=>{  if(e.target.value === '' || e.target.value === '0' || /^\d*[1-9]\d*$/.test(e.target.value)) { setEditAssetsForm({ ...editAssetsForm, costPerItem: e.target.value }) }; hideError('costPerItem')}} />
                        <span className="absolute top-[41px] end-[15px] w-[13px] h-[13px]" style={{background:"url('/assets/images/SAR-mini.svg')"}}></span>
                    </div>

                    <div className="mb-[15px]">
                        <MultiSelect label={'نسبة الإهلاك'} placeholder={'اختر نسبة الإهلاك السنوية'} options={depreciationRateOptions} error={errors?.depreciationRate} errorMessage={errors?.depreciationRate} value={editAssetsForm?.depreciationRate?.toString()} onChange={(option)=>{setEditAssetsForm({ ...editAssetsForm, depreciationRate: option?.value }); hideError('depreciationRate')}} />
                    </div>

                    <div className="mb-[15px]">
                        <MultiSelect label={'الوحدة'} placeholder={'اختر الوحدة الموجود بها الأصل'} options={unitsOptions} error={errors?.unitId} errorMessage={errors?.unitId} value={editAssetsForm?.unitId?._id ? editAssetsForm?.unitId?._id : editAssetsForm?.unitId} onChange={(option)=>{setEditAssetsForm({ ...editAssetsForm, unitId: option?.value, propertyId: option?.propertyId }); hideError('unitId')}} />
                    </div>

                    <div className="mb-[15px]">
                        <DateField label={'تاريخ الشراء أو التركيب'} placeholder={'اختر يوم تركيب الأصل أو الشراء اذا لم يركب بعد'} value={editAssetsForm?.purchaseDate} error={errors?.purchaseDate} errorMessage={errors?.purchaseDate} translateError={true} onChange={(date)=>{ setEditAssetsForm({ ...editAssetsForm, purchaseDate: date, installationDate: date }); hideError('purchaseDate')}} />
                    </div>

                    <div className="mb-[15px]">
                        <DateField label={'تاريخ آخر صيانة'} placeholder={'اختر يوم آخر صيانة تمت علي الأصل'} value={editAssetsForm?.lastMaintenanceDate} error={errors?.lastMaintenanceDate} errorMessage={errors?.lastMaintenanceDate} translateError={true} onChange={(date)=>{ setEditAssetsForm({ ...editAssetsForm, lastMaintenanceDate:date }); hideError('lastMaintenanceDate')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'عمر الأصل المتوقع'} placeholder={'اكتب عمر الأصل المتوقع بالسنين'} value={editAssetsForm?.expectedLifeSpan} error={errors?.expectedLifeSpan} errorMessage={errors?.expectedLifeSpan} translateError={true} onChange={(e)=>{  if(e.target.value === '' || e.target.value === '0' || /^\d*[1-9]\d*$/.test(e.target.value)) { setEditAssetsForm({ ...editAssetsForm, expectedLifeSpan: e.target.value }) }; hideError('expectedLifeSpan')}} />
                    </div>

                    <div className="mb-[15px]">
                        <MultiSelect label={'الضمان'} placeholder={'اختر هل يوجد ضمن أصل ام لا'} options={TrueOrFalseOptions} error={errors?.hasWarranty} errorMessage={errors?.hasWarranty} value={editAssetsForm?.hasWarranty} onChange={(option)=>{setEditAssetsForm({ ...editAssetsForm, hasWarranty: option?.value }); hideError('hasWarranty')}} />
                    </div>

                    <div className="mb-[15px]">
                        <label className="text-grey-900 text-[14px] font-[600] leading-[21px] mb-[3px] block">مستندات الضمان</label>
                        <div className="flex flex-nowrap gap-x-[10px] mb-[5px]">
                            <div className="w-[50%] text-[16px] font-[500] text-grey-600">
                                قم بتحميل مستندات الضمان إن وجد
                            </div>
                            <div className="w-[50%] text-end">
                                <div className="inline-block text-blue text-[16px] font-[500] cursor-pointer select-none" onClick={handleClickAttachments}>
                                    <span className="inline-block align-middle w-[24px] h-[24px] me-[8px]" style={{background:"url('/assets/images/export.svg')"}}></span>
                                    تحميل المستندات
                                </div>
                            </div>
                        </div>
                        <input type="file" ref={AttachmentFilesRef} className="hidden" multiple accept="image/jpeg, image/png, application/pdf" onChange={handleChangeAttachments} />
                        <div className="">
                            {editAssetsForm?.attachments?.length > 0 && <div className="mb-[0px]">
                                {editAssetsForm?.attachments?.map((file,index)=>{
                                    return (<div key={`attachment-${index}`} className="text-[16px] font-[500] text-grey-600">
                                        <span className="inline-block align-middle w-[24px] h-[24px] me-[3px]" style={{background:"url('/assets/images/tick-circle.svg')"}}></span>
                                        {file?.name}
                                        <span className="inline-block align-middle w-[24px] h-[24px] ms-[6px] cursor-pointer select-none" style={{background:"url('/assets/images/close-square.svg')"}} onClick={()=>removeUploadedAttachment(file)}></span>
                                    </div>)
                                })}
                            </div>}
                            {attachmentsFiles?.length > 0 && <div className="mb-[15px]">
                                {attachmentsFiles?.map((file,index)=>{
                                    return (<div key={`attachment-${index}`} className="text-[16px] font-[500] text-grey-600">
                                        <span className="inline-block align-middle w-[24px] h-[24px] me-[3px]" style={{background:"url('/assets/images/tick-circle.svg')"}}></span>
                                        {file?.name}
                                        <span className="inline-block align-middle w-[24px] h-[24px] ms-[6px] cursor-pointer select-none" style={{background:"url('/assets/images/close-square.svg')"}} onClick={()=>removeAttachment(file)}></span>
                                    </div>)
                                })}
                            </div>}
                            
                        </div>
                    </div>


                    <div className="text-end">
                        <NormalButton color={'!bg-danger'} label={'حذف الأصل'} onClick={handleSubmitDeleteِAsset} isDisabled={false} gabEnd={true} />
                        <NormalButton label={'تعديل الأصل'} onClick={handleSubmitEditAssets} isDisabled={isEditAssetsFormDisabled} />
                    </div>

                </NormalFormContainer>
            </MainContent>
        </PageMain>


        { deleteAssetModal && <ModalContainer heading="حذف اصل" handleCloseModal={handleCloseModalDelete}>
            <p className="text-[16px] text-grey-900 leading-[24px] font-[400]">هل أنت متأكد من حذف الأصل؟</p>
            <div className="text-end">
                <div className="text-grey-400 text-[18px] font-[600] inline-block cursor-pointer select-none me-[50px]" onClick={handleCloseModalDelete}>إلغاء</div>
                <NormalButton color={'!bg-danger'} label={'حذف الأصل'} onClick={handleSubmitDeleteInventoryAction} isDisabled={false} />
            </div>
        </ModalContainer> }


        {isLoading && <Loading showLoading={true} />}
        </div>
    )

}

export default AssetsEditPage;